import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ManageComponentsService } from '../manage-components.service';
import { NotificationsService } from 'angular2-notifications';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-component-image-upload',
  templateUrl: './component-image-upload.component.html',
  styleUrls: ['./component-image-upload.component.scss']
})
export class ComponentImageUploadComponent implements OnInit {

  selectedFile: File;
  form: FormGroup;
  loading: boolean = false;
  ngOnInit(): void {
    if(this.data.attachment_comp)
      this.attachment_comp = this.data.attachment_comp;
  }

  public attachment_comp;
  public imageName_comp;
  public tool_auto;
  ImageLoading: boolean = false
  constructor(private fb: FormBuilder,
    private _sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<ComponentImageUploadComponent>,
    private _componentservice: ManageComponentsService,
    private _notify: NotificationsService,
    @Inject(MAT_DIALOG_DATA)
    public data: any


  ) { }

  NoClick(): void {
    this.data = ''
    this.dialogRef.close();
  }


  uploadPhoto(newPhoto: string) {

    this.attachment_comp = newPhoto.split(",")[1];
    this.data.attachment_comp = this.attachment_comp;
    this.data.imageName_comp = this.selectedFile.name;
  }


  onSelectPhoto(event: any) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      this.selectedFile = event.target.files[0];
      reader.onloadend = (e) => {
        this.uploadPhoto(reader.result as string);
        
      }
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  sanitize(image: string) {
    return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);
  }

  saveCompImageDialog() {
    this._componentservice.saveCompartImage(this.data.compart_attach_auto, this.data.compartid_auto, 1, 0, this.data.comparttype_auto, 0, 0, this.attachment_comp, this.data.imageName_comp, this.data.modified_user)
    .subscribe(response => {
            if (response) {
              this._notify.success('Saved', 'Component Image Saved.');
            } else {
              this._notify.error('Error', 'Unable to save the Component image. Please contact TrackTreads support.');

            }
            this.dialogRef.close();

          });
  }


}
